import request from '@/utils/request'

// 生产环境api路径

export function clcfind (data) {
  return request({
    data: data,
    url: '/old/api/clcfind',
    method: 'post'
  })
}

export function getKeywordExtract (data) {
  return request({
    data: data,
    url: '/old/api/getKeywordExtract',
    method: 'post'
  })
}

export function searchJournalExpert (data) {
  return request({
    data: data,
    url: '/old/api/searchJournalExpert',
    method: 'post'
  })
}


// 翻译
export function getKeywordTranslate (data) {
  return request({
    data: data,
    url: '/old/keywordTranslate',
    method: 'post'
  })
}
// 获取历史热度
export function getKeywordAnalysis (data) {
  return request({
    data: data,
    url: '/old/keywordAnalysis ',
    method: 'post'
  })
}

// 中英文关联关键词
export function searchCoreKeywordsv2 (data) {
  return request({
    data: data,
    url: '/old/searchCoreKeywordsv2',
    method: 'post'
  })
}
// 开发环境api路径

// // 翻译
// export function getKeywordTranslate (data) {
//   return request({
//     data: data,
//     url: 'api/keywordTranslate',
//     method: 'post'
//   })
// }

// // 获取历史热度
// export function getKeywordAnalysis (data) {
//   return request({
//     data: data,
//     url: 'api/keywordAnalysis',
//     method: 'post'
//   })
// }

// // 中英文关联关键词
// export function searchCoreKeywordsv2 (data) {
//   return request({
//     data: data,
//     url: 'api/searchCoreKeywordsv2',
//     method: 'post'
//   })
// }



// WEBPACK FOOTER //
// ./src/api/retrieveField.js